/**
 * Offline income calculation
 * Headless - no GUI
 */

import type { GameState } from '../state.js';
import { getTotalCps } from './production.js';
import { getOfflineCapHours, getOfflineEfficiency } from './prestige.js';

/** Calculate offline IP earned */
export function calculateOfflineIp(state: GameState, elapsedMs: number): number {
  const capMs = getOfflineCapHours(state) * 3600_000;
  const effectiveMs = Math.min(elapsedMs, capMs);

  if (effectiveMs < 60_000) return 0; // minimum 1 minute offline

  const cps = getTotalCps(state);
  const efficiency = getOfflineEfficiency(state) / 100;
  const seconds = effectiveMs / 1000;

  return Math.floor(cps * seconds * efficiency);
}
